export default {
	extractFileNameFromResponse(response) {
		var filename = '';
		var disposition = response.headers['content-disposition'];
		if (disposition && disposition.indexOf('attachment') !== -1) {
			var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
			var matches = filenameRegex.exec(disposition);
			if (matches != null && matches[1]) {
				filename = matches[1].replace(/['"]/g, '');
			}
		}
		return filename;
	},

	extractMimeTypeFromResponse(response) {
		// Try to get Content-Type from response headers
		var contentType = response.headers['content-type'];
		if (contentType) {
			// Remove charset and other parameters if present
			return contentType.split(';')[0].trim();
		}
		return null;
	},

	extractFileInfoFromResponse(response) {
		return {
			filename: this.extractFileNameFromResponse(response),
			mimeType: this.extractMimeTypeFromResponse(response),
		};
	},
};
